import axios from 'axios';
import {createStore} from 'vuex';

//repositories -> modules
import organizationCategoryRepositoryStore from '#repositories/organizationCategoryRepository';
import authRepository from '#repositories/authRepository';
import sourceServiceCategoryStore from '#repositories/sourceServiceCategoryRepository';
import sourceServicePriorityStore from '#repositories/sourceServicePriorityRepository';
import sourceServiceTypeStore from '#repositories/sourceServiceTypeRepository';
import sourceServiceStore from '#repositories/sourceServiceRepository';
import organizationsRepositoryStore from '#repositories/organizationsRepository';
import personRepositoryStore from '#repositories/personRepository';
import sourceProcedureStore from '#repositories/sourceProcedureRepository';
import sourceProcedureSituationStore from '#repositories/sourceProcedureSituationRepository';
import sourceSituationStore from '#repositories/sourceSituationRepository';
import addressRepositoryStore from '#repositories/addressRepository';
import servicesStore from '#repositories/serviceRepository';
import sourceServiceProcedureOrganizationRepository from '#repositories/sourceServiceProcedureOrganizationRepository';
import procedureRepository from '#repositories/procedureRepository';
import fieldTypeStore from '#repositories/fieldTypeRepository';
import questionOptionStore from '#repositories/questionOptionRepository';
import questionStore from '#repositories/questionRepository';
import groupStore from '#repositories/groupRepository';
import questionnaireStore from '#repositories/questionnaireRepository';
import commentsStore from '#repositories/commentsRepository';
import collaboratorStore from "#repositories/collaboratorRepository";
import filesStore from "#repositories/filesRepository";
import attendanceChannelStore from '#repositories/attendanceChannelRepository';
import serviceStatusStore from "#repositories/serviceStatusRepository";
import servicesGroupsModule from '#repositories/servicesGroupsRepository';
import RolesStore from "#repositories/roleRepository";

import Role from "./modules/roles";
import usersModule from './modules/users/usersModule';
import DashboardsModule from "./modules/dashboards/dashboardsModule";

import {company} from '#constants/companyInfo';

export default createStore({
    state: {
        hideConfigButton: false,
        isPinned: true,
        showConfig: false,
        isTransparent: "",
        isRTL: false,
        color: "",
        isNavFixed: false,
        isAbsolute: false,
        showNavs: true,
        showSidenav: true,
        showNavbar: true,
        showFooter: true,
        showMain: true,
        navbarFixed:
            "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
        absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
        datatableDefautlOptions: {
            paging: true,
            select: true
        },
        errors: {},
        company: company,
        breadcrumbs: [],
        current: '',
        pages: [],
        params: {},
        paginationInfo: {},
        showPersonalData: true,
        showPersonName: true,
    },
    mutations: {
        toggleConfigurator(state) {
            state.showConfig = !state.showConfig;
        },
        setParams(state, data) {
            state.params = data
        },
        navbarMinimize(state) {
            const sidenav_show = document.querySelector(".g-sidenav-show");
            if (sidenav_show.classList.contains("g-sidenav-hidden")) {
                sidenav_show.classList.remove("g-sidenav-hidden");
                sidenav_show.classList.add("g-sidenav-pinned");
                state.isPinned = true;
            } else {
                sidenav_show.classList.add("g-sidenav-hidden");
                sidenav_show.classList.remove("g-sidenav-pinned");
                state.isPinned = false;
            }
        },
        sidebarType(state, payload) {
            state.isTransparent = payload;
        },
        cardBackground(state, payload) {
            state.color = payload;
        },
        navbarFixed(state) {
            if (state.isNavFixed === false) {
                state.isNavFixed = true;
            } else {
                state.isNavFixed = false;
            }
        },
        toggleEveryDisplay(state) {
            state.showNavbar = !state.showNavbar;
            state.showSidenav = !state.showSidenav;
            state.showFooter = !state.showFooter;
        },
        toggleHideConfig(state) {
            state.hideConfigButton = !state.hideConfigButton;
        },
        setErrors(state, data) {
            state.errors = data
        },
        resetError(state, data) {
            delete state.errors[data.field]
        },
        resetErrors(state) {
            state.errors = {}
        },
        setPages(state, data) {
            state.pages = data
        },
        setPaginationInfo(state, data) {
            state.paginationInfo = data
        },
        setShowPersonalData(state, data){
            state.showPersonalData = data
        },
        setCurrent(state, data){
            state.current = data
        }
    },
    actions: {
        toggleSidebarColor({commit}, payload) {
            commit("sidebarType", payload);
        },
        setCardBackground({commit}, payload) {
            commit("cardBackground", payload);
        },
        resetError({commit}, payload) {
            commit('resetError', payload);
        },
        resetErrors({commit}, data) {
            commit('resetErrors');
        },
        setErrors({commit}, payload) {
            commit('setErrors', payload);
        },
        setPages({commit, data}) {
            commit('setPages', data)
        },
        toggleEveryDisplay({commit}) {
            commit("toggleEveryDisplay");
        },
        toggleHideConfig({commit}) {
            commit("toggleHideConfig");
        }
    },
    modules: {
        organizationCategoryRepositoryStore,
        authRepository,
        sourceServiceCategoryStore,
        sourceServicePriorityStore,
        sourceServiceTypeStore,
        sourceServiceStore,
        personRepositoryStore,
        organizationsRepositoryStore,
        sourceProcedureStore,
        sourceProcedureSituationStore,
        sourceSituationStore,
        addressRepositoryStore,
        servicesStore,
        sourceServiceProcedureOrganizationRepository,
        procedureRepository,
        fieldTypeStore,
        questionOptionStore,
        questionStore,
        groupStore,
        questionnaireStore,
        commentsStore,
        collaboratorStore,
        filesStore,
        attendanceChannelStore,
        serviceStatusStore,
        RolesStore,
        Role,
        usersModule,
        DashboardsModule,
        servicesGroupsModule
    }
});
